<template>
  <div id="app">
    <!-- <router-view></router-view> -->
  
    <keep-alive >

        <router-view  v-if="$route.meta.keepAlive"></router-view>

    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"></router-view> 

  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
        let reSize = () =>{
          var deviceWidth = document.documentElement.clientWidth || window.innerWidth
          if (deviceWidth >= 750) {
          deviceWidth = 750
          }
          if (deviceWidth <= 320) {
          deviceWidth = 320
          }
          console.log((deviceWidth / 7.5))
          document.documentElement.style.fontSize = (deviceWidth / 7.5) + 'px'
    }
    reSize()
    window.onresize = () =>{
      reSize()
    }
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue